var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.23.676a.66.66 0 00-.205-.48A.695.695 0 009.532 0H.706a.71.71 0 00-.494.196.675.675 0 00-.204.48v10.777a.661.661 0 00.204.48.695.695 0 00.494.196h.23V.897h9.294V.676z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.341 1.733H2.452a.658.658 0 00-.666.65V13.21c0 .36.298.65.666.65h8.89c.367 0 .666-.29.666-.65V2.382a.658.658 0 00-.667-.65z"
  })));
}
export default SvgCopyIcon;